<template>
  <vx-card title>
    <div class="mt-5">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mt-5">
          <h6 class="mb-2">Cliente:</h6>
          {{ corporateName }}
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mt-5">
          <h6 class="mb-2">Tipo de Pedido:</h6>
          {{ orderType }}
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-1/3 mt-5">
          <h6 class="mb-2">Pagamento:</h6>
          à {{ payOrder }}
        </div>
        <div class="vx-col md:w-1/1 w-1/3 mt-5" v-if="invoice">
          <h6 class="mb-2">Nota Fiscal:</h6>
          {{ invoice }}
        </div>
        <div class="vx-col md:w-1/1 w-1/3 mt-5" v-if="budget">
          <h6 class="mb-2">Orçamento</h6>
          {{ budget }}
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-1/3 mt-5">
          <h6 class="mb-2">Condição de Pagamento:</h6>
          {{ terms }}
        </div>
        <div class="vx-col md:w-1/1 w-1/3 mt-5">
          <h6 class="mb-2">Contrato: Ouro S/N</h6>
          {{ gold }}
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-1/3 mt-5">
          <h6 class="mb-2">Data:</h6>
          {{ date }}
        </div>
        <div class="vx-col md:w-1/1 w-1/3 mt-5">
          <h6 class="mb-2">Nome do Responsável:</h6>
          {{ personName }}
        </div>
        <div class="vx-col md:w-1/1 w-1/3 mt-5">
          <h6 class="mb-2">Cargo:</h6>
          {{ personRole }}
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-1/3 mt-5">
          <h6 class="mb-2">Consultor:</h6>
          {{ user.name }}
        </div>
        <div class="vx-col md:w-1/1 w-1/3 mt-5">
          <h6 class="mb-2">Observação:</h6>
          {{ generalObservation }}
        </div>
      </div>
    </div>
  </vx-card>
</template>


<script>
import { baseApiUrl } from "@/global";
import axios from "axios";
import { momentJS } from "@/helpers";
import router from "@/router";
export default {
  components: {},
  data() {
    return {
      type: "",
      idOrder: "",
      corporateName: "",
      orderType: null,
      payOrder: null,
      gold: null,
      generalObservation: null,
      itemsPerPage: 100,
      products: [],
      personName: "",
      personRole: "",
      productsSelected: [],
      date: null,
      terms: "",
      invoice: "",
      budget: "",
      user: "",
      fetchURL: "",
    };
  },
  computed: {},
  methods: {
    async loadOrder(fetchUrl) {
      try {
        this.$vs.loading();
        const response = await axios.get(fetchUrl);
        this.$vs.loading.close();
        this.$vs.loading.close();
        this.date = momentJS().formatDateTimeForPTBR(
          response.data.order[0].dateOrder
        );
        this.idOrder = response.data.order[0].idOrder;
        this.payOrder = response.data.order[0].payOrder;
        this.personName = response.data.order[0].personName;
        this.personRole = response.data.order[0].personRole;
        this.orderType = response.data.order[0].orderType;
        this.terms = response.data.order[0].terms;
        this.gold = response.data.order[0].gold;
        this.generalObservation = response.data.order[0].generalObservation;
        this.corporateName = response.data.order[0].corporateName;
        this.invoice = response.data.order[0].invoice;
        this.budget =
          response.data.order[0].budget == "comOrcamento"
            ? "Com Orçamento"
            : "Sem Orçamento";

        let user = {
          id: response.data.order[0].idUser,
          label: response.data.order[0].userName,
          name: response.data.order[0].userName,
        };

        this.user = user;

        for (let product of response.data.products) {
          let obj = {
            idProduct: product.idProduct,
            name: product.name,
            code: product.code,
            category: product.category,
            price: product.price,
            amount: product.amount,
          };

          this.productsSelected.push(obj);
        }
      } catch (error) {
        console.log(error);

        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });

        if (error.response.status == "400") {
          router.push(`/${this.type[1]}`).catch(() => {});
        }
      }
    },
  },
  async created() {
    this.type = this.$route.path.split("/");
    if (this.type[1] == "equipamentos") {
      const fetchUrl = `${baseApiUrl}/equipmentOrder/getEquipmentOrderById/${this.$route.params.idOrder}`;
      await this.loadOrder(fetchUrl);
    }
    if (this.type[1] == "suprimentos") {
      const fetchUrl = `${baseApiUrl}/suppliesOrder/getSuppliesOrderById/${this.$route.params.idOrder}`;
      await this.loadOrder(fetchUrl);
    }
    if (this.type[1] == "pecas") {
      const fetchUrl = `${baseApiUrl}/partsOrder/getPartsOrderById/${this.$route.params.idOrder}`;
      await this.loadOrder(fetchUrl);
    }
    if (this.type[1] == "suprimentos-locacao") {
      const fetchUrl = `${baseApiUrl}/leaseSuppliesOrder/getLeaseSuppliesOrderById/${this.$route.params.idOrder}`;
      await this.loadOrder(fetchUrl);
    }
    if (this.type[1] == "mao-de-obra") {
      const fetchUrl = `${baseApiUrl}/laborOrder/getLaborOrderById/${this.$route.params.idOrder}`;
      await this.loadOrder(fetchUrl);
    }
    if (this.type[1] == "locacao") {
      const fetchUrl = `${baseApiUrl}/leaseOrder/getLeaseOrderById/${this.$route.params.idOrder}`;
      await this.loadOrder(fetchUrl);
    }
      if (this.type[1] == "ouro") {
      const fetchUrl = `${baseApiUrl}/goldOrder/getGoldOrderById/${this.$route.params.idOrder}`;
      await this.loadOrder(fetchUrl);
    }
  },
};
</script>
 
